import { ITimeSlot } from '../interface/time-slot';
export class TimeSlot implements ITimeSlot{
    constructor(public SlotId : number,public SlotDescription : string, public DoctorId : number){
        
    }
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/time-slot.ts